import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import HotRankSection from './components/HotRankSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '天美麻花星空影视',
    url: window.location.origin,
    description: '天美麻花星空影视免费观看，麻花星空影视免费观看高清不缓冲流畅播放，极速观看免费影视大全，最新电影电视剧免费在线。',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${window.location.origin}/category?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '天美麻花星空影视',
    url: window.location.origin,
    description: '提供高清流畅的免费在线影视观看服务',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <div className="min-h-screen bg-background-950">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedSection />
          <LatestSection />
          <HotRankSection />
          <section className="py-12 md:py-16 bg-background-900">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto text-center">
                <h2 className="text-white text-xl md:text-2xl font-bold mb-4">
                  天美麻花星空影视免费观看
                </h2>
                <p className="text-foreground-400 text-sm md:text-base max-w-3xl mx-auto leading-relaxed">
                  麻花星空影视免费观看高清不缓冲流畅播放，极速观看免费影视大全。
                  最新电影电视剧免费在线，天美麻花星空影视免费观看提供麻花星空影视高清免费在线播放，
                  不缓冲不卡顿，极速流畅观看电影电视剧综艺，免费影视大全。
                </p>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}